<template>
  <div class="courses-container">
    <div class="courses-title">
      <span :class="[{'title': activeStatus === 'new'}, {'sub-title': activeStatus !== 'new'}]" @click="activeStatus='new'">最新课程</span>
      <span :class="[{'title': activeStatus === 'hot'}, {'sub-title': activeStatus !== 'hot'}]" @click="activeStatus='hot'">最热课程</span>
      <a :href="newCourseData.more" class="more" target="_blank"
        @mouseenter="hoverImg = true"
        @mouseleave="hoverImg = false">
        更多
        <img src="../../../static/images/icon/login-icon/help_more_hover.svg"
          v-if="hoverImg">
        <img src="../../../static/images/icon/login-icon/help_more.svg"
          v-else>
      </a>
    </div>
    <div class="courses-content-recommend">
      <div class="content-without-img" v-for="item in items">
        <a class="content-title" :href="item.link" target="_blank">{{item.title}}</a>
        <!-- <span class="num">5283人学习</span> -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './courses.scss'
</style>

<script>
  // export { default } from './courses.js'
  export default {
    data () {
      return {
        hoverImg: false,
        activeStatus: 'new'
      }
    },
    props: {
      newCourseData: {
        type: Object,
        default () {
          return {
            more: '/academy/learning/',
            items: [{
              link: "/academy/course/6628748116352827395/",
              title: "广告监测与数据分析（一）"
            }, {
              link: "/academy/course/6628748318803492868/",
              title: "广告监测与数据分析（二）"
            }, {
              link: "/academy/course/6628747352377131011/",
              title: "品牌类广告资源概览（一）"
            }, {
              link: "/academy/course/6628747556497129475/",
              title: "品牌类广告资源概览（二）"
            }]
          }
        }
      },
      hotCourseData: {
        type: Object,
        default () {
          return {
            more: '/academy/learning/',
            items: [{
              'link': '/academy/course/35/',
              'title': '今日头条广告创意优化指南-上篇（视频课程）'
            }, {
              'link': '/academy/course/6485247213231407117/',
              'title': '账户优化方法论【视频课程】'
            }, {
              'link': '/academy/course/6516392309502771214/',
              'title': '飞鱼CRM系统（视频课程）'
            }, {
              'link': '/academy/course/36/',
              'title': '今日头条广告创意优化指南-下篇（视频课程）'
            }]
          }
        }
      }
    },
    computed: {
      items () {
        if (this.activeStatus === 'new') {
          return this.newCourseData.items.slice(0, 4)
        } else {
          return this.hotCourseData.items.slice(0, 4)
        }
      }
    },
    mounted () {
    },
    methods: {
    }
  }
</script>